import React from "react";
import { HomeOutlined } from "@ant-design/icons";

export const BreadcrumbConfig = {
	ManageStates: {
		title: "Manage States",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "States" },
		],
	},
	ManageCity: {
		title: "Manage Cities",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Cities" },
		],
	},
	ManageArea: {
		title: "Manage Areas",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Areas" },
		],
	},
	ManageLocation: {
		title: "Manage Locations",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Locations" },
		],
	},
	ManageInquiryArea: {
		title: "Manage Inquiry Areas",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Areas" },
		],
	},
	ManagePremises: {
		title: "Manage Premises",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Premises" },
		],
	},
	ManagePremisesType: {
		title: "Manage Premises Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Premises Types" },
		],
	},
	ManageDSA: {
		title: "Manage DSA",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "DSA" },
		],
	},
	ManageDepartments: {
		title: "Manage Departments",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Departments" },
		],
	},
	ManageDesignation: {
		title: "Manage Designations",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Designations" },
		],
	},
	ManageBank: {
		title: "Manage Banks",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Banks" },
		],
	},
	ManageSegment: {
		title: "Manage Segments",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Segments" },
		],
	},
	ManageSupplier: {
		title: "Manage Suppliers",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Suppliers" },
		],
	},
	ManageWhitelistIp: {
		title: "Manage Whitelist IPs",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Whitelist IPs" },
		],
	},
	ManageBrand: {
		title: "Manage Brands",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Brands" },
		],
	},
	ManageFuelOption: {
		title: "Manage Fuel Options",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Fuel Options" },
		],
	},
	ManageTransmissionType: {
		title: "Manage Transmission Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Transmission Types" },
		],
	},
	ManageVehicleType: {
		title: "Manage Vehicle Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Vehicle Types" },
		],
	},
	ManagePurchaseType: {
		title: "Manage Purchase Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Purchase Types" },
		],
	},
	ManageCharacteristics: {
		title: "Manage Characteristics",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Characteristics" },
		],
	},
	ManageFamilyMember: {
		title: "Manage Family Members",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Family Members" },
		],
	},
	CompanySettings: {
		title: "Company Settings",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Company Settings" },
		],
	},
	ManageBuyingFor: {
		title: "Manage Relation",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Relation" },
		],
	},
	ManageDriveCar: {
		title: "Manage Drive Car",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Drive Car" },
		],
	},
	ManageDailyRun: {
		title: "Manage Daily Run",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Daily Run" },
		],
	},
	ManageDrivenMode: {
		title: "Manage Driven Modes",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Driven Modes" },
		],
	},
	ManageGST: {
		title: "Manage GST",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "GST" },
		],
	},
	ManageCC: {
		title: "Manage CC",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "CC" },
		],
	},
	ManageColor: {
		title: "Manage Colors",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Colors" },
		],
	},
	ManageAccessoryType: {
		title: "Manage Accessory Type",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Accessory Type" },
		],
	},
	ManageModel: {
		title: "Manage Models",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Models" },
		],
	},
	ManageMunicipalTax: {
		title: "Manage Municipal Tax",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Municipal Tax" },
		],
	},
	ManageMunicipalityName: {
		title: "Manage Municipality Name",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Municipality Name" },
		],
	},
	ManageVariant: {
		title: "Manage Variants",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Variants" },
		],
	},
	ManageAccessory: {
		title: "Manage Accessories",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Accessories" },
		],
	},
	ManageInquiryMode: {
		title: "Manage Inquiry Modes",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Modes" },
		],
	},
	ManageInquiryMedia: {
		title: "Manage Inquiry Media",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Media" },
		],
	},
	ManageInquiryRating: {
		title: "Manage Inquiry Rating",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Rating" },
		],
	},
	ManageInsuranceCompany: {
		title: "Manage Insurance Companies",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Insurance Companies" },
		],
	},
	ManageInsuranceCategory: {
		title: "Manage Insurance Categories",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Insurance Categories" },
		],
	},
	InsuranceOfferPending: {
		title: "Insurance - Pending",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Offers" },
			{ name: "Pending" },
		],
	},
	InsuranceLostCasePending: {
		title: "Pending Lost Case Approval",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Offers" },
			{ name: "Pending Lost Cases" },
		],
	},
	InsuranceOfferHistory: {
		title: "Insurance - History",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Offers" },
			{ name: "History" },
		],
	},
	InsuranceClosing: {
		title: "Insurance - Closing",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Offers" },
			{ name: "Closing" },
		],
	},
	InsuranceOfferRenewal: {
		title: "Insurance - Renewals & Rollovers",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Offers" },
			{ name: "Renewals & Rollovers" },
		],
	},
	InsuranceProduct: {
		title: "Manage Insurance Products",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Products" },
		],
	},
	InsuranceQuotationPending: {
		title: "Quotation ",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Quotations" },
			{ name: "Pending Discount" },
		],
	},
	InsuranceQuotationPendingApproval: {
		title: "Pending Approval",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Quotations" },
			{ name: "Pending Approval" },
		],
	},
	InsuranceQuotationHistory: {
		title: "History",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Quotations" },
			{ name: "Discount History" },
		],
	},
	ManageEmploymentType: {
		title: "Manage Employment Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Employment Types" },
		],
	},
	ManageZone: {
		title: "Manage Zones",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Zones" },
		],
	},
	ManageDealType: {
		title: "Manage Deal Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Deal Types" },
		],
	},
	ManageDealCategory: {
		title: "Manage Deal Categories",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Deal Categories" },
		],
	},
	ManageCustomerType: {
		title: "Manage Customer Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Customer Types" },
		],
	},
	ManageInquiryClosureType: {
		title: "Manage Inquiry Closure Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Closure Types" },
		],
	},
	ManageInquiryFollowupAction: {
		title: "Manage Inquiry Followup Action",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Inquiry Followup Action" },
		],
	},
	ManageRole: {
		title: "Manage Roles",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Roles" },
		],
	},
	ManageUser: {
		title: "Manage Users",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Users" },
		],
	},
	ManageUsageType: {
		title: "Manage Usage Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Usage Types" },
		],
	},
	ManageTestDriveLocation: {
		title: "Manage Test Drive Location",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Test Drive Location" },
		],
	},
	ManagePurpose: {
		title: "Manage Purposes",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Purposes" },
		],
	},
	ManagePassingType: {
		title: "Manage Passing Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Passing Types" },
		],
	},
	ManagePaymentModes: {
		title: "Manage Payment Modes",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Payment Modes" },
		],
	},
	ManagePaymentStatus: {
		title: "Manage Payment Status",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Payment Status" },
		],
	},
	ManageApprovedCompany: {
		title: "Manage Approved Companies",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Approved Companies" },
		],
	},
	ManageLevel: {
		title: "Manage Levels",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Levels" },
		],
	},
	ManagePayType: {
		title: "Manage Pay Types",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Pay Types" },
		],
	},
	ManageHoliday: {
		title: "Manage Holidays",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Holidays" },
		],
	},
	ManageSMS: {
		title: "Manage SMS",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "SMS" },
		],
	},
	ManageEmail: {
		title: "Manage Emails",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Emails" },
		],
	},
	ManageLoanSource: {
		title: "Manage Loan Sources",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Loan Sources" },
		],
	},
	ManageRTOCharges: {
		title: "Manage RTO Charges",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "RTO Charges" },
		],
	},
	ManageRTOPlaces: {
		title: "Manage RTO Places",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "RTO Places" },
		],
	},
	ManageInfo: {
		title: "Manage Info",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Manage Info" },
		],
	},
	ImportTransaction: {
		title: "Import In-Transit Cars",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Wholesale Purchase" },
			{ name: "Import In-Transit Cars" },
		],
	},
	InTransit: {
		title: "In Transit",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Wholesale Purchase" },
			{ name: "In Transit" },
		],
	},
	InStock: {
		title: "In Stock",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Wholesale Purchase" },
			{ name: "In Stock" },
		],
	},
	InquiryMediaSubCategory: {
		title: "Inquiry Sub Category",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Inquiry Sub Category" },
		],
	},
	SalesProfile: {
		title: "Sales Profile",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Sales Profile" },
		],
	},
	ActiveInquiries: {
		title: "Active Inquiries",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Active Inquiries" },
		],
	},
	BookedInquiries: {
		title: "Booked Inquiries",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Booked Inquiries" },
		],
	},
	ClosedInquiries: {
		title: "Closed Inquiries",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Closed Inquiries" },
		],
	},
	LostInquiries: {
		title: "Lost Cases",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Lost Cases" },
		],
	},
	SuccessfulInquiries: {
		title: "Successful Closure",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Inquiry" },
			{ name: "Successful Closure" },
		],
	},
	ManageScheme: {
		title: "Manage Schemes",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Manage Schemes" },
		],
	},
	ManagePackages: {
		title: "Packages",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Bookings" },
			{ name: "Packages" },
		],
	},
	ManageKitty: {
		title: "Manage Kitty",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Manage Kitty" },
		],
	},
	ManageZForm: {
		title: "Z-Forms",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Z-Forms" },
		],
	},
	ManageZFormSC: {
		title: "Z-Forms (SC)",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Z-Forms(SC)" },
		],
	},
	Delivered: {
		title: "Delivered",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Delivered" },
		],
	},
	Cancelled: {
		title: "Cancelled",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Cancelled" },
		],
	},
	ReadyForDelivery: {
		title: "Ready For Delivery",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Ready For Delivery" },
		],
	},
	ChassisAllocation: {
		title: "Chassis Allocation",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Chassis Allocation" },
		],
	},
	SchemeDiscountRequest: {
		title: "Scheme Discount Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Scheme Discount Request" },
		],
	},
	KittyDiscountRequest: {
		title: "Kitty Discount Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Kitty Discount Request" },
		],
	},
	MunicipalRequest: {
		title: "Municipal Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Municipal Request" },
		],
	},
	CorporateDiscountRequest: {
		title: "Corporate Discount Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Corporate Discount Request" },
		],
	},
	RTODiscountRequest: {
		title: "RTO Discount Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "RTO Discount Request" },
		],
	},
	AccessoryDiscountRequest: {
		title: "Accessory Discount Request",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Accessory Discount Request" },
		],
	},
	ResetZForm: {
		title: "Reset Z-Form",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Reset Z-Form" },
		],
	},
	IRR: {
		title: "IRR",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "IRR" },
		],
	},
	ApprovalFinance: {
		title: "Approval",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Offers" },
		],
	},
	Profile: {
		title: "Profile",
		path: [{ name: <HomeOutlined />, link: "/dashboard" }, { name: "Profile" }],
	},
	BlankPage: {
		title: "Blank Page",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Blank Page" },
		],
	},
	TableExample: {
		title: "Table Example",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Table Example" },
		],
	},
	ManageNCBPercentage: {
		title: "Manage NCB Percentage",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "NCB Percentage" },
		],
	},
	ManageAddOns: {
		title: "Manage Add-Ons",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Add-Ons" },
		],
	},
	ManageDepreciationRates: {
		title: "Manage Depreciation Rates",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Depreciation Rates" },
		],
	},
	Insurance: {
		title: "Manage Insurance Tariff Rates",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance Tariff Rates" }
		],
	},
	InsuranceTPRates: {
		title: "Manage Insurance TP Rates",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance TP Rates" }
		],
	},
	ManageBankAccounts: {
		title: "Manage Bank Accounts",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "Manage Bank Accounts" },
		],
	},
	Payments: {
		title: "Payment Entry",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment Entry" },
		],
	},
	Refunds: {
		title: "Refunds",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Refunds" },
		],
	},
	OpenCancellation: {
		title: "Open Cancellation",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Open Cancellation" },
		],
	},
	Disbursements: {
		title: "Disbursements",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Disbursements" },
		],
	},
	ExpectedDisbursements: {
		title: "Expected Disbursements",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Exp. Disbursements" },
		],
	},
	ByZForm: {
		title: "By Z-Form",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "By Z-Form" },
		],
	},
	OpenZForm: {
		title: "Open Z-Forms",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Open Z-Form" },
		],
	},
	PaymentReceived: {
		title: "Payment - Pending Deposit",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment - Pending Deposit" },
		],
	},
	PaymentDeposited: {
		title: "Payment - Pending Reco",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment - Pending Reco" },
		],
	},
	PaymentSuccessful: {
		title: "Payment - Reco Done",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment - Reco Done" },
		],
	},
	PaymentFailed: {
		title: "Payment-Failed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment-Failed" },
		],
	},
	PaymentCancelled: {
		title: "Payment-Cancelled",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Fund Flow" },
			{ name: "Payment-Cancelled" },
		],
	},
	AllPaymentList: {
		title: "Payment Entry",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payment Entry" },
		],
	},
	ReceivedPaymentList: {
		title: "Payment - Pending Deposit",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payment - Pending Deposit" },
		],
	},
	DepositedPaymentList: {
		title: "Payment - Pending Reco",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payment - Pending Reco" },
		],
	},
	SuccessfulPaymentList: {
		title: "Payment - Reco Done",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payment - Reco Done" },
		],
	},
	FailedPaymentList: {
		title: "Payments - Failed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payments" },
			{ name: "Failed" },
		],
	},
	OutstandingPaymentList: {
		title: "Payments - Outstanding",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payments" },
			{ name: "Outstanding" },
		],
	},
	PayoutsAll: {
		title: "Finance Payouts - All",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "All" },
		],
	},
	UnclaimedFinancePayout: {
		title: "Finance Payouts - Unclaimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "Unclaimed" },
		],
	},
	ClaimedFinancePayout: {
		title: "Finance Payouts - Claimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "Claimed" },
		],
	},
	ApprovedFinancePayout: {
		title: "Finance Payouts - Approved",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "Approved" },
		],
	},
	ReceivedFinancePayout: {
		title: "Finance Payouts - Received",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "Received" },
		],
	},
	RejectedFinancePayout: {
		title: "Finance Payouts - Rejected",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Payouts" },
			{ name: "Rejected" },
		],
	},
	CorporatePayoutsAll: {
		title: "Corporate Payouts - All",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "All" },
		],
	},
	UnclaimedCorporatePayout: {
		title: "Corporate Payouts - Unclaimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "Unclaimed" },
		],
	},
	ClaimedCorporatePayout: {
		title: "Corporate Payouts - Claimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "Claimed" },
		],
	},
	ApprovedCorporatePayout: {
		title: "Corporate Payouts - Approved",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "Approved" },
		],
	},
	ReceivedCorporatePayout: {
		title: "Corporate Payouts - Received",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "Received" },
		],
	},
	RejectedCorporatePayout: {
		title: "Corporate Payouts - Rejected",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Corporate" },
			{ name: "Payouts" },
			{ name: "Rejected" },
		],
	},
	InsurancePayoutsAll: {
		title: "Insurance Payouts - All",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "All" },
		],
	},
	UnclaimedInsurancePayout: {
		title: "Insurance Payouts - Unclaimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "Unclaimed" },
		],
	},
	ClaimedInsurancePayout: {
		title: "Insurance Payouts - Claimed",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "Claimed" },
		],
	},
	ApprovedInsurancePayout: {
		title: "Insurance Payouts - Approved",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "Approved" },
		],
	},
	ReceivedInsurancePayout: {
		title: "Insurance Payouts - Received",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "Received" },
		],
	},
	RejectedInsurancePayout: {
		title: "Insurance Payouts - Rejected",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Insurance" },
			{ name: "Payouts" },
			{ name: "Rejected" },
		],
	},
	ManageInsuranceSegment: {
		title: "Segments For Insurance",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Admin" },
			{ name: "Segments" },
			{ name: "List" },
		],
	},

	ReceiptReportRequest: {
		title: "Receipt Report",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Receipt Report" },
		],
	},

	FinancePipelineReportRequest: {
		title: "Finance Pipeline Summary",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Reports", link: "/reports"  },
			{ name: "Booking & Sales" },
			{ name: "Finance Pipeline Summary" },
		],
	},
	FinancePipelineDetailsReportRequest: {
		title: "Finance Pipeline Report Details",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Reports", link: "/reports"  },
			{ name: "Booking & Sales" },
			{ name: "Finance Pipeline Report Details" },
		],
	},
	SalesReport: {
		title: "Sales Report",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Booking & Sales" },
			{ name: "Sales Report" },
		],
	},
	CorporateReport: {
		title: "Corporate Report",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Reports", link: "/reports"  },
			{ name: "Booking & Sales" },
			{ name: "Corporate Report" },
		],
	},
	FinanceReport: {
		title: "Finance Report",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "Finance Report" },
		],
	},
	DSAReport: {
		title: "DSA Report",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Finance" },
			{ name: "DSA Report" },
		],
	},
	ManagePMS: {
		title: "Manage PMS",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "PMS" },
		],
	},
	ManageBharatPassing: {
		title: "Manage RTO Charges - Bharat Passing",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Administration" },
			{ name: "RTO Charges" },
		],
	},
	ManageDRF: {
		title: "DRF Listing",
		path: [
			{ name: <HomeOutlined />, link: "/dashboard" },
			{ name: "Sales" },
			{ name: "DRF Listing" },
		],
	},
};
